import type { FC } from "react";

import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import WWOSearchTrafficOrganic from "app/pages/website-performance/components/SearchTraffic/organic/WWOSearchTrafficOrganic";
import {
    getBrandedNonBrandedCtaLinkForSI,
    getKeywordsCtaLinkForSI,
} from "app/pages/website-performance/components/SearchTraffic/utlis";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";

export const WWOSearchTrafficOrganicContainerSI: FC = () => {
    return (
        <WWOSearchTrafficOrganic
            getKeywordsCtaLink={getKeywordsCtaLinkForSI(WEBSITE_ANALYSIS_WIDGET_NAMES.trafficKeywords)}
            getBrandedNonBrandedCtaLink={getBrandedNonBrandedCtaLinkForSI}
            brandedNonBrandedUnlockHook={{
                component: "WsWebSearchOverview",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            keywordsUnlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
        />
    );
};
